import React, { useState, useEffect } from 'react';

const Productos = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const productosList = [
    'Cajas de Microcorrugado',
    'Cajas de Corrugado',
    'Cajas para regalos',
    'Promocionales',
    'Exhibidores',
    'Parasoles',
    'Estuches'
  ];

  const productosImages = [
    '/imgs/productos-prod1.png',
    '/imgs/productos-prod2.png',
    '/imgs/productos-prod3.png',
    '/imgs/productos-prod4.png',
    '/imgs/productos-prod5.png',
    '/imgs/productos-prod6.png'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % productosImages.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [productosImages.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = shadows => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + productosImages.length) % productosImages.length);
  };

  const goToNext = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % productosImages.length);
  };

  return (
    <section id="productos" className="section productos">
      <div className="productos-container">
        <div className="productos-content">
          <div className="productos-list-container">
            <ul className="productos-list">
              {productosList.map((producto, index) => (
                <li key={index}>{producto}</li>
              ))}
            </ul>
          </div>

          <div className="productos-slider-container">
            <button className="productos-slider-nav productos-slider-nav-prev" onClick={goToPrevious}>
              ‹
            </button>

            <div className="productos-slider-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
              {productosImages.map((image, index) => (
                <div key={index} className="productos-slider-slide">
                  <img 
                    src={image} 
                    alt={`Producto ${index + 1}`}
                    className="productos-slider-image"
                  />
                </div>
              ))}
            </div>

            <button className="productos-slider-nav productos-slider-nav-next" onClick={goToNext}>
              ›
            </button>

            <div className="productos-slider-indicators">
              {productosImages.map((_, index) => (
                <button
                  key={index}
                  className={`productos-slider-indicator ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Productos;
